import React, {Component} from 'react';
class MovieInformation extends Component{
    render(){
        const{currentMovie}=this.props;
        return(
    <div>
    <h1>{currentMovie.title}</h1>
    <p>{currentMovie.rating}</p>
    <p>{currentMovie.description}</p>
    <p>{currentMovie.releaseYear}</p>
    <p>{currentMovie.categories}</p>
    <img 
    alt={currentMovie.title}
    src={currentMovie.posterUrl}
    height={600}
    />
    </div>
        );
    }
}
export default MovieInformation;